import React, { Suspense } from "react";
import { LinearProgress } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { routeConfig } from "../../../shared/config/routeConfig/routeConfig";

const AppRouter = () => {
  return (
    <Suspense fallback={<LinearProgress />}>
      <Routes>
        {Object.values(routeConfig).map(({ element, path }) => (
          <Route
            key={path}
            path={path}
            element={
              <Suspense fallback={<LinearProgress />}>{element}</Suspense>
            }
          />
        ))}
      </Routes>
    </Suspense>
  );
};
export default AppRouter;
